export default 'https://tme.understood.org/assets/ticket.3cdee01b.jpg'